import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "price-and-payment-filter",
  "data-component-name": "price-and-payment-filter",
  "data-testid": "price-payment-filter"
}
const _hoisted_2 = { "data-role": "facet-filter" }
const _hoisted_3 = { class: "lblTitle" }
const _hoisted_4 = { class: "text-toggle d-flex justify-center" }
const _hoisted_5 = {
  class: "pp-range-input",
  "data-for": "price-payment",
  "data-testid": "range-input"
}
const _hoisted_6 = {
  class: "pp-range-input",
  "data-testid": "range-input"
}
const _hoisted_7 = { class: "pp-range-slider" }
const _hoisted_8 = { class: "pp-range-slider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterMenuLineItem = _resolveComponent("FilterMenuLineItem")!
  const _component_TextToggle = _resolveComponent("TextToggle")!
  const _component_RangeInput = _resolveComponent("RangeInput")!
  const _component_RangeSlider = _resolveComponent("RangeSlider")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FilterMenuLineItem, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expandFilter())),
            isSelected: !!(_ctx.facetFilters[_ctx.filterTypePrice] || _ctx.facetFilters[_ctx.filterTypePayment]),
            title: _ctx.title
          }, null, 8, ["isSelected", "title"])
        ], 512), [
          [_vShow, !_ctx.priceFilterSelected && !_ctx.filterSelected]
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TextToggle, {
              class: "price-payment-toggle",
              options: _ctx.toggleOptions,
              modelValue: _ctx.priceToggleSelectedValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.priceToggleSelectedValue) = $event))
            }, null, 8, ["options", "modelValue"])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createVNode(_component_RangeInput, {
              range: _ctx.priceRange,
              onInputValueSet: _ctx.inputValueSetPrice,
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setUpdateStorePrice = true)),
              step: _ctx.priceIncrement,
              currency: true,
              minLabel: _ctx.minLabel,
              maxLabel: _ctx.maxLabel,
              currencyIcon: _ctx.currencyIcon,
              "component-name": "PriceFilterPrice"
            }, null, 8, ["range", "onInputValueSet", "step", "minLabel", "maxLabel", "currencyIcon"])
          ], 512), [
            [_vShow, _ctx.priceToggleSelected]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createVNode(_component_RangeInput, {
              range: _ctx.paymentRange,
              onInputValueSet: _ctx.inputValueSetPayment,
              onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setUpdateStorePayment = true)),
              step: _ctx.paymentIncrement,
              currency: true,
              minLabel: _ctx.minLabel,
              maxLabel: _ctx.maxLabel,
              currencyIcon: _ctx.currencyIcon,
              "component-name": "PriceFilterPayment"
            }, null, 8, ["range", "onInputValueSet", "step", "minLabel", "maxLabel", "currencyIcon"])
          ], 512), [
            [_vShow, !_ctx.priceToggleSelected]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            _createVNode(_component_RangeSlider, {
              step: _ctx.priceIncrement,
              range: _ctx.priceRange,
              setRange: _ctx.setPriceRange,
              modelValue: _ctx.priceModel,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.priceModel) = $event)),
              onSliderValueUpdated: _ctx.updatePriceRange,
              onSliderValueSet: _ctx.updateStorePrice
            }, null, 8, ["step", "range", "setRange", "modelValue", "onSliderValueUpdated", "onSliderValueSet"])
          ], 512), [
            [_vShow, _ctx.priceToggleSelected]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _createVNode(_component_RangeSlider, {
              step: _ctx.paymentIncrement,
              range: _ctx.paymentRange,
              setRange: _ctx.setPaymentRange,
              modelValue: _ctx.paymentModel,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.paymentModel) = $event)),
              onSliderValueUpdated: _ctx.updatePaymentRange,
              onSliderValueSet: _ctx.updateStorePayment
            }, null, 8, ["step", "range", "setRange", "modelValue", "onSliderValueUpdated", "onSliderValueSet"])
          ], 512), [
            [_vShow, !_ctx.priceToggleSelected]
          ])
        ], 512), [
          [_vShow, _ctx.priceFilterSelected]
        ])
      ])
    ]),
    _: 1
  }))
}